import Big from 'big.js'
import {groupBy} from 'remeda'

import {useIsAuthenticatedValue} from '@/auth/hooks/useIsAuthenticated'
import type {SupportedLocales} from '@/lib/locale/locale'
import queries from '@/queries/queries'
import {getCart} from '@/services/cartService'

export function useCart(locale: SupportedLocales, enabled = true) {
  const isAuthenticated = useIsAuthenticatedValue()

  return useQuery(
    queries.getQueryOptions({
      name: 'cart',
      params: [locale],
      queryFn: async ({signal}) => getCart({isAuthenticated, locale, signal}),
      select: data => {
        // Share the same schema of useCustomCartValue
        return {
          ...data,
          itemsLength: data.items.reduce((acc, item) => acc + item.quantity, 0),
          itemsValue: data.items.reduce(
            (acc, item) => acc.plus(Big(item.price).mul(item.quantity)),
            Big(0),
          ),
          items: groupBy(data.items, item => item.seller ?? item.retailer),
          originalItems: data.items,
        }
      },
      enabled,
    }),
  )
}
